import { PublishRecordService } from '@src/services/publish/PublishRecordService';
import { useDatoClient } from '@src/stores-v2/StoreContext';
import { useMemo } from 'react';

/**
 * Facade hook for `PublishRecordService` — the DI seam for component reads of
 * publish records, so components/hooks never touch `PublishRecordRepository`
 * directly (Components → Services → Repositories). Mirrors
 * `useSpeakerManagementService`.
 */
export function usePublishRecordService(): PublishRecordService {
  const datoClientStore = useDatoClient();
  return useMemo(
    () => new PublishRecordService(datoClientStore.publishRecordRepository),
    [datoClientStore.publishRecordRepository],
  );
}
